var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { routerLink } from "../helpers/router-helper";
export var useLink = function (props, defaultTag) {
    var Component = useMemo(function () {
        var _a, _b, _c;
        if (!props) {
            return defaultTag !== null && defaultTag !== void 0 ? defaultTag : 'div';
        }
        if (props.to) {
            return (_c = (_b = (_a = props.component) !== null && _a !== void 0 ? _a : routerLink.Component) !== null && _b !== void 0 ? _b : defaultTag) !== null && _c !== void 0 ? _c : 'div';
        }
        if (props.href) {
            return 'a';
        }
        return defaultTag !== null && defaultTag !== void 0 ? defaultTag : 'div';
    }, [defaultTag, props]);
    var targetProps = useMemo(function () {
        return Component === 'a' && props.isTargetBlank
            ? { target: '_blank', rel: 'noopener noreferrer', href: props.href, to: props.to }
            : { href: props.href, to: props.to };
    }, [Component, props.href, props.isTargetBlank, props.to]);
    return useMemo(function () {
        return React.forwardRef(function (_props, ref) { return (React.createElement(Component, __assign({}, targetProps, _props, { ref: ref }))); });
    }, [Component, targetProps]);
};
